import { useState, useCallback } from "react";

const SupportHttp = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
  
    const sendRequest = useCallback(async (requestConfig, applyData,errorCallback) => {
      setIsLoading(true);
      setError(null);
  
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SUPPORT_URL}${requestConfig.url}`,
          {
            method: requestConfig.method ? requestConfig.method : "GET",
            headers: requestConfig.headers
              ? requestConfig.headers
              : {
                  "Content-Type": "application/json",
                  authorization: `Bearear ${localStorage.getItem("token")}`,
                  Accept: "application/json",
                },
            body: requestConfig.body ? JSON.stringify(requestConfig.body) : null,
          }
        );
  
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data);
        }
  
        const data = await response.json();
        applyData(data);
      } catch (err) {
        setError(err.message || "Something went wrong!");
        if (errorCallback) {
         
           errorCallback(err.message || "Something went wrong!");
         }
      }
      setIsLoading(false);
    }, []);
  
    return {
      isLoading,
      error,
      sendRequest,
    };
  };

export default SupportHttp